module.exports = __webpack_public_path__ + "static/media/DoThingsIcon.cbdc4881.svg";